var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.125C18 0.45 17.55 0 16.875 0H1.125C0.45 0 0 0.45 0 1.125V7.875C0 8.55 0.45 9 1.125 9H16.875C17.55 9 18 8.55 18 7.875V1.125ZM16.875 7.875H1.125V1.125H16.875V7.875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25H3.375V6.75H2.25V2.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditHeader);
export default __webpack_public_path__ + "static/media/editHeader.c4a7ed02c612f9fe70eacffad3e7bd4f.svg";
export { ForwardRef as ReactComponent };